import {
  HIDE_MODAL,
  SHOW_REGISTER,
  SHOW_LOGIN,
  SHOW_MODAL,
  SHOW_RESET_PASSWORD,
  SHOW_VERIFY_EMAIL,
  SHOW_STEPS,
  HIDE_STEPS,
} from "../actions/types";
const initialModalsState = { showResetPassword: false, showVerifyEmail: false };
const initialState = {
  ...initialModalsState,
  showModal: false,
  isShowSteps: false,
  // if isMember === true  => we show login , else => register
  isMember: false,
};

function ui_control(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case SHOW_REGISTER:
      return {
        ...state,
        showModal: true,
        isMember: false,
        ...initialModalsState,
      };
    case SHOW_LOGIN:
      return {
        ...state,
        showModal: true,
        isMember: true,
        ...initialModalsState,
      };
    case HIDE_MODAL:
      return {
        ...initialState,
      };
    case SHOW_STEPS:
      return {
        ...state,
        isShowSteps: true,
      };
    case HIDE_STEPS:
      return {
        ...state,
        isShowSteps: false,
      };
    case SHOW_MODAL:
      return {
        ...state,
        showModal: true,
      };
    case SHOW_RESET_PASSWORD:
      return {
        ...state,
        showModal: true,
        showResetPassword: true,
        showVerifyEmail: false,
      };
    case SHOW_VERIFY_EMAIL:
      return {
        ...state,
        showModal: true,
        showResetPassword: false,
        showVerifyEmail: true,
      };
    default:
      return state;
  }
}

export default ui_control;
